import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useProfile = (): ContextValue => useContext(Context);
